define('plugin/promotion/view/PromotionServiceBadgeView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    return LayoutView.extend({

        template: '#promotion_service_badge_view'

    });

});
